import React, {useState} from 'react'
import {Link, Outlet} from 'react-router-dom'

const menuss = [
    {
      id: 1,
      name: 'Home',
      url: '/',
      active:'active-menu'
    },
    {
      id:2,
      name: 'Batteries',
      url: '/batteries',
      active:''
    },
    {
      id: 3,
      name: 'Locations',
      url: '/maps',
      active:''
    }
  ]
function Layout() {
  const [menus, setMenus] = useState(menuss)
  const handleClick = (id) => {
    const menu = menus.filter(menu => menu.id === id )
    const newMenus = menus.map(men =>
      menu.id === id ?
        {...men}
        : {...men}
        )
    setMenus(newMenus)
    
  }

  return (
    <>
      <nav className='App-nav' >
        <ul className='App-nav-ul'>
          {menus.map((menu, index) =>
            <li key={menu.name + index} onClick={() => handleClick(menu.id)}>
              <Link to={menu.url} className={`App-link-nav-li ${menu.active}`} >{menu.name }</Link>
            </li>
          )}

        </ul>
      </nav>
      <Outlet />
    </>
  )
}

export default Layout